import type { ChatPlugin } from '#types/plugin/chat'
import enhancedLiveChat from '#core/integrations/enhanced-live-chat'
import sierraChat from '#core/integrations/sierra-chat'
import { languageConfig } from '../../config/integrations/livechat'

export default defineNuxtPlugin<{ chat: ChatPlugin }>(() => {
  const { enableChat, configLivechat } = useFeatureFlags()
  const locale = useLocale()

  if (!enableChat) {
    const open = () => console.warn('Chat is disabled by feature flag')
    open()

    return {
      provide: {
        chat: {
          open,
          available: ref(false)
        }
      }
    }
  }

  // TBL NORA and certain regions in EMEA use Sierra Chat
  if (configLivechat.enabled && configLivechat.sierraRegions?.includes(locale)) {
    return sierraChat({
      cssPath: '/sierra/css/SierraChatCodeCanvasTBL.css',
      hideLauncherOnHomepage: ['en-ca,', 'en-us', 'fr-ca', 'en-gb', 'fr-fr', 'de-de', 'it-it', 'es-us', 'es-es', 'nl-nl']
    })
  }

  else {
    return enhancedLiveChat({
      cssPath: '/livechat/css/LiveChatCodeCanvasTBL.css',
      brand: 'TBL',
      languageConfig,
      eswConfigDevName: 'MIAW_TBL'
    })
  }
})
